exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper .v-avatar{align-items:center;border-radius:50%;display:inline-flex;justify-content:center;line-height:normal;position:relative;text-align:center;vertical-align:middle}#wacg-wrapper .v-avatar .v-icon,#wacg-wrapper .v-avatar .v-image,#wacg-wrapper .v-avatar .v-responsive__content,#wacg-wrapper .v-avatar img,#wacg-wrapper .v-avatar svg{border-radius:inherit;display:inline-flex;height:inherit;width:inherit}#wacg-wrapper .v-avatar--tile{border-radius:0}", ""]);

// exports
